var _style, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;fill:#FAFAFA;}\n\t.st1{display:none;fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-328-1242h1440V622H-328V-1242z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-26-1106h1138V472H-26V-1106z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.1,2.7c0.6,0,1.1,0.5,1.1,1.1s-0.5,1.1-1.1,1.1C9.5,5,9,4.5,9,3.8C9,3.2,9.5,2.7,10.1,2.7 M10.1,6.3 c1.4,0,2.5-1.1,2.5-2.5s-1.1-2.5-2.5-2.5S7.6,2.4,7.6,3.8C7.7,5.2,8.8,6.3,10.1,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.4,21.3c-2.3,0-4.1-1.9-4.1-4.1c0-2.3,1.9-4.1,4.1-4.1s4.1,1.9,4.1,4.1S12.7,21.3,10.4,21.3 M9.5,9.5 C9.3,9,9.6,8.4,10.2,8.2c0.3-0.1,0.5-0.1,0.8,0.1c0.2,0.1,0.4,0.4,0.5,0.6l0.8,2.8h-1.9c-0.1,0-0.2,0-0.3,0L9.5,9.5z M14,13h2.6 c0.4,0,0.7-0.3,0.7-0.7s-0.3-0.7-0.7-0.7h-2.8l-1-3.2c-0.2-0.6-0.6-1.1-1.2-1.4C11,6.8,10.4,6.8,9.8,6.9c-1.3,0.4-2,1.7-1.6,3 l0.6,2C6.6,12.6,5,14.7,5,17.2c0,3,2.4,5.5,5.5,5.5s5.5-2.4,5.5-5.5C15.9,15.5,15.1,14,14,13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.2,21.8l-1.7-6.4c-0.1-0.4-0.5-0.6-0.8-0.5c-0.4,0.1-0.6,0.5-0.5,0.8l1.7,6.4c0.1,0.3,0.3,0.5,0.6,0.5 c0.1,0,0.1,0,0.2,0C19.1,22.5,19.3,22.1,19.2,21.8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMr);
export default __webpack_public_path__ + "static/media/ic_mr.e67009d935921fdfa9ab0536f89969a6.svg";
export { ForwardRef as ReactComponent };